import * as Yup from 'yup'

export const challengeSchema = Yup.object().shape({
  trai_pool: Yup.number().required('validation-required'),
  paid: Yup.boolean().required('validation-required'),
  name: Yup.string().required('validation-required'),
  description: Yup.string().required('validation-required'),
})
